"use client";
import { lazy, Suspense } from "react";
import { matchRoute } from "@softmax/web-addresses";
import { usePathname } from "../../navigation/use-pathname";
import { useFeedbackViewer } from "./use-feedback-viewer";

const FeedbackLauncher = lazy(() =>
  import("../launcher/feedback-launcher").then((module) => ({
    default: module.FeedbackLauncher,
  })),
);

export function FeedbackBootstrap() {
  const route = matchRoute(usePathname());
  const isDisabledPath =
    route.name === "signIn" || route.name === "completeProfile";
  const { launcherEnabled, revokeLauncher } = useFeedbackViewer({
    isDisabledPath,
  });

  if (isDisabledPath || !launcherEnabled) return null;

  return (
    <Suspense fallback={null}>
      <FeedbackLauncher onRevoked={revokeLauncher} />
    </Suspense>
  );
}
